import type { ReactNode } from 'react'
import { AlertIcon, InboxIcon, PlugIcon } from './icons'
import styles from './EmptyState.module.css'

export interface EmptyStateProps {
  /** `not-connected`: a data source is missing (RULES: never show invented numbers). */
  kind?: 'empty' | 'not-connected' | 'error'
  title: string
  children?: ReactNode
  action?: ReactNode
  compact?: boolean
}

const ICON = { empty: InboxIcon, 'not-connected': PlugIcon, error: AlertIcon }

export function EmptyState({ kind = 'empty', title, children, action, compact = false }: EmptyStateProps) {
  const Icon = ICON[kind]
  return (
    <div className={`${styles.empty} ${styles[kind]} ${compact ? styles.compact : ''}`} role={kind === 'error' ? 'alert' : undefined}>
      <span className={styles.icon}><Icon size={compact ? 18 : 22} /></span>
      <p className={styles.title}>{title}</p>
      {children && <div className={styles.body}>{children}</div>}
      {action && <div className={styles.action}>{action}</div>}
    </div>
  )
}
